import React, { Component } from "react";
import PropTypes from "prop-types";
import HumanitarianHealthLogoWhiteText from "../../../img/HumanitarianHealthLogoWhiteTextHorizontal.png";
import MailIcon from "@material-ui/icons/Mail";
import FacebookIcon from "@material-ui/icons/Facebook";
import YouTubeIcon from "@material-ui/icons/YouTube";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import * as Theme from "../../../app/Theme";

class HLFooter extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,

        sideBarOpen: PropTypes.bool,
        onSideBarArrowClick: PropTypes.func,

        wideModeBool: PropTypes.bool,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),

        sideBarOpen: false,
        onSideBarArrowClick: () => console.log("onSideBarArrowClick"),

        wideModeBool: true,
    };

    state = {};

    onMailingListClick = () => {
        window.open("http://eepurl.com/cuEV35");
    };

    onFacebookClick = () => {
        window.open("https://www.facebook.com/HopkinsHumanitarianHealth/");
    };

    onTwitterClick = () => {
        window.open("https://twitter.com/Humanit_Health");
    };

    onLinkedInClick = () => {
        window.open("https://www.linkedin.com/groups/5016124");
    };

    onYouTubeClick = () => {
        window.open("https://www.youtube.com/channel/UCE1-nrGFmKCcpnCTEHAzf-Q");
    };

    onJohnsHopkinsUnivClick = () => {
        window.open("http://jhu.edu");
    };

    render() {
        const spacing = 10;
        const textSize = 18;
        const textColor = Theme.whiteColor;
        const dividerFontSize = 30;

        const mediaStyle = {
            cursor: "pointer",
            marginBottom: 0,
            marginLeft: 10,
            marginRight: spacing,
            marginTop: 0,
        };

        const iconStyle = {
            cursor: "pointer",
        };

        const dividerStyle = {
            fontSize: dividerFontSize,
            marginBottom: 0,
            marginRight: spacing,
            marginTop: 0,
        };

        const mediaDiv = (
            <div
                style={{
                    alignItems: "center",
                    color: textColor,
                    display: "flex",
                    //display : "inline-block",
                    flexDirection: "row",
                    //flexWrap      : "nowrap",
                    fontSize: textSize,
                    //height        : 100,
                    width: 660, // prevents text from wrapping
                    ...Theme.textFontStyle,
                }}
            >
                <MailIcon onClick={this.onMailingListClick} style={iconStyle} />

                <p onClick={this.onMailingListClick} style={mediaStyle}>
                    Mailing List
                </p>

                <p style={dividerStyle}>|</p>

                <FacebookIcon onClick={this.onFacebookClick} style={iconStyle} />

                <p onClick={this.onFacebookClick} style={mediaStyle}>
                    Facebook
                </p>

                <p style={dividerStyle}>|</p>

                <TwitterIcon onClick={this.onTwitterClick} style={iconStyle} />

                <p onClick={this.onTwitterClick} style={mediaStyle}>
                    Twitter
                </p>

                <p style={dividerStyle}>|</p>

                <LinkedInIcon onClick={this.onLinkedInClick} style={iconStyle} />

                <p onClick={this.onLinkedInClick} style={mediaStyle}>
                    LinkedIn
                </p>

                <p style={dividerStyle}>|</p>

                <YouTubeIcon onClick={this.onYouTubeClick} style={iconStyle} />

                <p onClick={this.onYouTubeClick} style={mediaStyle}>
                    YouTube
                </p>
            </div>
        );

        // const copyrightDiv =
        //     <p
        //         onClick = {this.onJohnsHopkinsUnivClick}
        //         style   = {{
        //             ...Theme.textFontStyle,
        //             color      : textColor,
        //             cursor     : "pointer",
        //             fontSize   : textSize,
        //             fontWeight : 700,
        //             margin     : 0,
        //         }}
        //     >
        //         © Johns Hopkins University
        //     </p>;

        const textDiv = (
            <div
                style={{
                    //alignItems     : "center",
                    //display        : "flex",
                    //flexDirection  : "column",
                    marginRight: 90, // puts text at minimum distance required from logo
                }}
            >
                {mediaDiv}
                {/*{copyrightDiv}*/}
            </div>
        );

        const logo = (
            <img
                onClick={this.onJohnsHopkinsUnivClick}
                style={{
                    cursor: "pointer",
                    height: 150,
                }}
                src={HumanitarianHealthLogoWhiteText}
                alt="HumanitarianHealthLogoWhiteText"
            />
        );

        // const contactLink =
        //     <Link
        //         href    = {"mailto:humanithealth@jhu.edu"}
        //         key     = {"contactLink"}
        //         style   = {{
        //             color   : Theme.whiteColor,
        //             ...Theme.labelFontStyle,
        //             cursor  : "pointer",
        //         }}
        //         underline = {"hover"}
        //     >
        //         humanithealth@jhu.edu
        //     </Link>;
        //
        // const contactLabel =
        //     <TLabel
        //         caption = {"Contact: "}
        //         key     = {"contactLabel"}
        //         style   = {{
        //             color : Theme.whiteColor,
        //             ...Theme.labelFontStyle,
        //             marginLeft : 50,
        //         }}
        //     />;

        return (
            <div
                style={{
                    backgroundColor: Theme.HL_SecondaryColor,
                    display: "flex",
                    alignItems: "center", // vertically center stuff
                    height: 164,
                    justifyContent: "center", // horizontally center stuff
                    width: "100%",
                    zIndex: 10000, // so it goes over app side bar
                }}
            >
                {textDiv}
                {/*{contactLabel}*/}
                {/*&nbsp;*/}
                {/*{contactLink}*/}
                {logo}
            </div>
        );
    }
}

export default HLFooter;
